var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExpandableInputBase',{attrs:{"value":_vm.value,"staticSize":true}},[[_c('input',{class:{ 'el-input__inner': true, clickable: true },attrs:{"disabled":true,"size":"4"},domProps:{"value":_vm.value}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }